import { Formik, FormikConfig } from 'formik';
import { ChallengeScoreUpForm } from '~/components/Challenge/Score/Form/ChallengeScoreUpForm';
import {
  ChallengeScoreUpValues,
  useScoreUpSchema,
} from '~/components/Challenge/Score/Form/ChallengeScoreUpForm.hooks';

export type ChallengeScoreUpFormikProps = Pick<FormikConfig<ChallengeScoreUpValues>, 'onSubmit'>;
export const ChallengeScoreUpFormik = ({ onSubmit }: ChallengeScoreUpFormikProps) => {
  const validationSchema = useScoreUpSchema();

  return (
    <Formik
      initialValues={{ balance: 0, count: 1 }}
      initialTouched={{ count: true }}
      onSubmit={onSubmit}
      validationSchema={validationSchema}>
      <ChallengeScoreUpForm />
    </Formik>
  );
};
